import React from 'react'
import { Link, usePage } from '@inertiajs/inertia-react'
import {
    canEditSiaModule,
    canViewSiaModule,
    hasSiaCatalogosAccess,
    hasSiaRecruitmentReportsAccess,
} from '../../utils/siaPermissions'
import {
    canEditSecomRecords,
    canSecomCatalogos,
    canSecomReports,
    canSecomUpdates,
    canViewSecomRecords,
    hasAnySecomMenuAccess,
} from '../../utils/secomPermissions'
import {
    canCobranzaBitacoraView,
    canCobranzaCatalogsView,
    canCobranzaRecordsView,
    hasAnyCobranzaMenuAccess,
} from '../../utils/cobranzaPermissions'
import { canCustomerServiceBitacoraView } from '../../utils/customerServicePermissions'

function pathFromPageUrl(url) {
    if (!url && typeof window !== 'undefined') {
        return window.location.pathname
    }
    const path = String(url || '').split('?')[0]
    return path.startsWith('/') ? path : `/${path}`
}

function IconClipboard() {
    return (
        <span className="menu-icon">
            <span className="svg-icon svg-icon-2">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 3C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3ZM14 17H7V15H14V17ZM17 13H7V11H17V13ZM17 9H7V7H17V9Z" />
                </svg>
            </span>
        </span>
    )
}

function IconPeople() {
    return (
        <span className="menu-icon">
            <span className="svg-icon svg-icon-2">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z" />
                </svg>
            </span>
        </span>
    )
}

function IconPhone() {
    return (
        <span className="menu-icon">
            <span className="svg-icon svg-icon-2">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.68 14.91 16.08 14.82 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z" />
                </svg>
            </span>
        </span>
    )
}

function IconMoney() {
    return (
        <span className="menu-icon">
            <span className="svg-icon svg-icon-2">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.8 10.9C9.53 10.31 8.8 9.7 8.8 8.75C8.8 7.43 10.54 6.55 12.8 6.55C14.81 6.55 16.19 7.37 16.64 8.43H18.77C18.28 6.61 16.65 5.38 14 5.05V3H12V5.08C9.34 5.43 7.8 7.06 7.8 8.85C7.8 11 9.35 12.21 12.2 12.91C14.91 13.57 15.2 14.39 15.2 15.29C15.2 16.31 13.91 17.4 11.75 17.4C9.44 17.4 8.13 16.59 7.56 15.33H5.36C6 17.41 8.13 18.68 11 18.92V21H13V18.95C15.67 18.66 17.2 17.16 17.2 15.25C17.2 13 15.7 11.68 11.8 10.9Z" />
                </svg>
            </span>
        </span>
    )
}

function IconWallet() {
    return (
        <span className="menu-icon">
            <span className="svg-icon svg-icon-2">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 18V19C21 20.1 20.1 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.9 3.89 3 5 3H19C20.1 3 21 3.9 21 5V6H12C10.89 6 10 6.9 10 8V16C10 17.1 10.89 18 12 18H21ZM12 16H22V8H12V16ZM16 13.5C15.17 13.5 14.5 12.83 14.5 12S15.17 10.5 16 10.5 17.5 11.17 17.5 12 16.83 13.5 16 13.5Z" />
                </svg>
            </span>
        </span>
    )
}

/**
 * Módulos operativos en el menú principal del administrador (fuera del panel SIA).
 * Permisos: sia.manage.* (migración a permisos propios pendiente).
 */
export default function OperationalModulesMenu({ searchPath }) {
    const { url } = usePage()
    const pathname = pathFromPageUrl(url)
    const sp = typeof searchPath === 'function' ? searchPath : (fragment) => pathname.indexOf(fragment)

    const canView = (module) => canViewSiaModule(module, true)
    const canEdit = (module) => canEditSiaModule(module, true)

    const bitacoraPrefix = '/admin/bitacora-prospectos'
    const bitacoraActive = pathname === bitacoraPrefix || pathname.startsWith(`${bitacoraPrefix}/`)
    const bitacoraCreateActive = pathname === `${bitacoraPrefix}/create`
    const bitacoraIndexActive = pathname === bitacoraPrefix || (bitacoraActive && !bitacoraCreateActive && !pathname.includes('/edit'))

    const reclutamientoPrefix = '/admin/reclutamiento'
    const reclutamientoActive = pathname === reclutamientoPrefix || pathname.startsWith(`${reclutamientoPrefix}/`)
    const reclutamientoCreateActive = pathname.endsWith('/registros/create')
    const reclutamientoIndexActive =
        pathname === `${reclutamientoPrefix}/registros` ||
        (pathname.startsWith(`${reclutamientoPrefix}/registros/`) &&
            !reclutamientoCreateActive &&
            !pathname.includes('/reportes') &&
            !pathname.includes('/catalogos'))
    const reclutamientoReportsActive = pathname.startsWith(`${reclutamientoPrefix}/reportes`)
    const reclutamientoCatalogsOpen = pathname.startsWith(`${reclutamientoPrefix}/catalogos`)
    const reclutamientoCatalogActive = (slug) =>
        pathname === `${reclutamientoPrefix}/catalogos/${slug}` || pathname.startsWith(`${reclutamientoPrefix}/catalogos/${slug}/`)

    const customerServicePrefix = '/admin/atencion-cliente'
    const customerServiceActive = pathname === customerServicePrefix || pathname.startsWith(`${customerServicePrefix}/`)
    const customerServiceCreateActive = pathname.endsWith('/registros/create')
    const customerServiceIndexActive =
        pathname === `${customerServicePrefix}/registros` ||
        (pathname.startsWith(`${customerServicePrefix}/registros/`) && !customerServiceCreateActive)
    const customerServiceBitacoraActive = pathname.startsWith(`${customerServicePrefix}/bitacora`)
    const customerServiceCatalogsOpen = pathname.startsWith(`${customerServicePrefix}/catalogos`)
    const customerServiceCatalogActive = (slug) =>
        pathname === `${customerServicePrefix}/catalogos/${slug}` ||
        pathname.startsWith(`${customerServicePrefix}/catalogos/${slug}/`)

    const cobranzaActive = sp('cobranza') > -1 && sp('commission') === -1
    const cobranzaRecordsActive = sp('cobranza/registros') > -1
    const cobranzaBitacoraActive = sp('cobranza/bitacora') > -1
    const cobranzaCatalogActive = sp('cobranza/catalogos') > -1

    const secomPrefix = '/admin/secom'
    const secomActive = pathname === secomPrefix || pathname.startsWith(`${secomPrefix}/`)
    const secomRecordsActive =
        pathname === `${secomPrefix}/registros` ||
        (pathname.startsWith(`${secomPrefix}/registros/`) && !pathname.includes('/actualizaciones'))
    const secomCreateActive = pathname.endsWith('/registros/create')
    const secomUpdatesActive = pathname.startsWith(`${secomPrefix}/actualizaciones`)
    const secomReportsActive = pathname.startsWith(`${secomPrefix}/reportes`)
    const secomCatalogActive = pathname.startsWith(`${secomPrefix}/catalogos`)

    return (
        <>
            {canView('bitacora') && (
                <div
                    data-kt-menu-trigger="click"
                    className={'menu-item menu-accordion ' + (bitacoraActive ? 'active hover show' : '')}
                >
                    <span className="menu-link">
                        <IconClipboard />
                        <span className="menu-title">Bitácora de prospectos</span>
                        <span className="menu-arrow"></span>
                    </span>
                    <div className="menu-sub menu-sub-accordion">
                        {canEdit('bitacora') && (
                            <div className="menu-item">
                                <Link
                                    className={'menu-link ' + (bitacoraCreateActive ? 'active' : '')}
                                    href={route('prospect-log.create')}
                                >
                                    <span className="menu-bullet">
                                        <span className="bullet bullet-dot"></span>
                                    </span>
                                    <span className="menu-title">Agregar registro</span>
                                </Link>
                            </div>
                        )}
                        <div className="menu-item">
                            <Link
                                className={'menu-link ' + (bitacoraIndexActive ? 'active' : '')}
                                href={route('prospect-log.index')}
                            >
                                <span className="menu-bullet">
                                    <span className="bullet bullet-dot"></span>
                                </span>
                                <span className="menu-title">Ver registros</span>
                            </Link>
                        </div>
                    </div>
                </div>
            )}

            {canView('reclutamiento') && (
                <div
                    data-kt-menu-trigger="click"
                    className={'menu-item menu-accordion ' + (reclutamientoActive ? 'active hover show' : '')}
                >
                    <span className="menu-link">
                        <IconPeople />
                        <span className="menu-title">Reclutamiento</span>
                        <span className="menu-arrow"></span>
                    </span>
                    <div className="menu-sub menu-sub-accordion">
                        {canEdit('reclutamiento') && (
                            <div className="menu-item">
                                <Link
                                    className={'menu-link ' + (reclutamientoCreateActive ? 'active' : '')}
                                    href={route('recruitment.create')}
                                >
                                    <span className="menu-bullet">
                                        <span className="bullet bullet-dot"></span>
                                    </span>
                                    <span className="menu-title">Agregar registro</span>
                                </Link>
                            </div>
                        )}
                        <div className="menu-item">
                            <Link
                                className={'menu-link ' + (reclutamientoIndexActive ? 'active' : '')}
                                href={route('recruitment.index')}
                            >
                                <span className="menu-bullet">
                                    <span className="bullet bullet-dot"></span>
                                </span>
                                <span className="menu-title">Ver registros</span>
                            </Link>
                        </div>
                        {hasSiaRecruitmentReportsAccess(true) && (
                            <div className="menu-item">
                                <Link
                                    className={'menu-link ' + (reclutamientoReportsActive ? 'active' : '')}
                                    href={route('recruitment.reports')}
                                >
                                    <span className="menu-bullet">
                                        <span className="bullet bullet-dot"></span>
                                    </span>
                                    <span className="menu-title">Reportes</span>
                                </Link>
                            </div>
                        )}
                        {hasSiaCatalogosAccess('reclutamiento', true) && (
                            <div
                                data-kt-menu-trigger="click"
                                className={'menu-item menu-accordion ' + (reclutamientoCatalogsOpen ? 'active hover show' : '')}
                            >
                                <span className="menu-link">
                                    <span className="menu-bullet">
                                        <span className="bullet bullet-dot"></span>
                                    </span>
                                    <span className="menu-title">Catálogos</span>
                                    <span className="menu-arrow"></span>
                                </span>
                                <div className="menu-sub menu-sub-accordion">
                                    <div className="menu-item">
                                        <Link
                                            className={'menu-link ' + (reclutamientoCatalogActive('puestos') ? 'active' : '')}
                                            href={route('recruitment.catalogs.index', 'puestos')}
                                        >
                                            <span className="menu-title">Puestos</span>
                                        </Link>
                                    </div>
                                    <div className="menu-item">
                                        <Link
                                            className={
                                                'menu-link ' + (reclutamientoCatalogActive('medios-reclutamiento') ? 'active' : '')
                                            }
                                            href={route('recruitment.catalogs.index', 'medios-reclutamiento')}
                                        >
                                            <span className="menu-title">Medios de reclutamiento</span>
                                        </Link>
                                    </div>
                                    <div className="menu-item">
                                        <Link
                                            className={'menu-link ' + (reclutamientoCatalogActive('medios-contacto') ? 'active' : '')}
                                            href={route('recruitment.catalogs.index', 'medios-contacto')}
                                        >
                                            <span className="menu-title">Medios de contacto</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {canView('atencion-cliente') && (
                <div
                    data-kt-menu-trigger="click"
                    className={'menu-item menu-accordion ' + (customerServiceActive ? 'active hover show' : '')}
                >
                    <span className="menu-link">
                        <IconPhone />
                        <span className="menu-title">Atención al cliente</span>
                        <span className="menu-arrow"></span>
                    </span>
                    <div className="menu-sub menu-sub-accordion">
                        {canEdit('atencion-cliente') && (
                            <div className="menu-item">
                                <Link
                                    className={'menu-link ' + (customerServiceCreateActive ? 'active' : '')}
                                    href={route('customer-service.create')}
                                >
                                    <span className="menu-bullet">
                                        <span className="bullet bullet-dot"></span>
                                    </span>
                                    <span className="menu-title">Agregar registro</span>
                                </Link>
                            </div>
                        )}
                        <div className="menu-item">
                            <Link
                                className={'menu-link ' + (customerServiceIndexActive ? 'active' : '')}
                                href={route('customer-service.index')}
                            >
                                <span className="menu-bullet">
                                    <span className="bullet bullet-dot"></span>
                                </span>
                                <span className="menu-title">Ver registros</span>
                            </Link>
                        </div>
                        {canCustomerServiceBitacoraView() && (
                            <div className="menu-item">
                                <Link
                                    className={'menu-link ' + (customerServiceBitacoraActive ? 'active' : '')}
                                    href={route('customer-service.bitacora.index')}
                                >
                                    <span className="menu-bullet">
                                        <span className="bullet bullet-dot"></span>
                                    </span>
                                    <span className="menu-title">Ver bitácora</span>
                                </Link>
                            </div>
                        )}
                        {hasSiaCatalogosAccess('atencion-cliente', true) && (
                            <div
                                data-kt-menu-trigger="click"
                                className={'menu-item menu-accordion ' + (customerServiceCatalogsOpen ? 'active hover show' : '')}
                            >
                                <span className="menu-link">
                                    <span className="menu-bullet">
                                        <span className="bullet bullet-dot"></span>
                                    </span>
                                    <span className="menu-title">Catálogos</span>
                                    <span className="menu-arrow"></span>
                                </span>
                                <div className="menu-sub menu-sub-accordion">
                                    <div className="menu-item">
                                        <Link
                                            className={'menu-link ' + (customerServiceCatalogActive('tipo-visita') ? 'active' : '')}
                                            href={route('customer-service.catalogs.index', 'tipo-visita')}
                                        >
                                            <span className="menu-title">Tipo de visita</span>
                                        </Link>
                                    </div>
                                    <div className="menu-item">
                                        <Link
                                            className={
                                                'menu-link ' + (customerServiceCatalogActive('tipo-otro-seguro') ? 'active' : '')
                                            }
                                            href={route('customer-service.catalogs.index', 'tipo-otro-seguro')}
                                        >
                                            <span className="menu-title">Tipo de otro seguro</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {hasAnyCobranzaMenuAccess() && (
                <div
                    data-kt-menu-trigger="click"
                    className={
                        'menu-item menu-accordion ' +
                        (cobranzaActive ? 'here show hover ' : '') +
                        (cobranzaActive ? 'active' : '')
                    }
                >
                    <span className="menu-link">
                        <IconMoney />
                        <span className="menu-title">Cobranza</span>
                        <span className="menu-arrow" />
                    </span>
                    <div className={'menu-sub menu-sub-accordion ' + (cobranzaActive ? 'show' : '')}>
                        {canCobranzaRecordsView() && (
                            <div className={'menu-item ' + (cobranzaRecordsActive ? 'active' : '')}>
                                <Link className="menu-link" href={route('cobranza.records.index')}>
                                    <span className="menu-bullet"><span className="bullet bullet-dot" /></span>
                                    <span className="menu-title">Ver registros</span>
                                </Link>
                            </div>
                        )}
                        {canCobranzaBitacoraView() && (
                            <div className={'menu-item ' + (cobranzaBitacoraActive ? 'active' : '')}>
                                <Link className="menu-link" href={route('cobranza.bitacora.index')}>
                                    <span className="menu-bullet"><span className="bullet bullet-dot" /></span>
                                    <span className="menu-title">Ver bitácora</span>
                                </Link>
                            </div>
                        )}
                        {canCobranzaCatalogsView() && (
                            <div
                                data-kt-menu-trigger="click"
                                className={
                                    'menu-item menu-accordion ' +
                                    (cobranzaCatalogActive ? 'here show hover active' : '')
                                }
                            >
                                <span className="menu-link">
                                    <span className="menu-bullet"><span className="bullet bullet-dot" /></span>
                                    <span className="menu-title">Catálogos</span>
                                    <span className="menu-arrow" />
                                </span>
                                <div className={'menu-sub menu-sub-accordion ' + (cobranzaCatalogActive ? 'show' : '')}>
                                    <div className="menu-item">
                                        <Link className="menu-link" href={route('cobranza.catalogs.index', 'tipo-contacto')}>
                                            <span className="menu-title">Tipo de contacto</span>
                                        </Link>
                                    </div>
                                    <div className="menu-item">
                                        <Link className="menu-link" href={route('cobranza.catalogs.index', 'status')}>
                                            <span className="menu-title">Status de cobranza</span>
                                        </Link>
                                    </div>
                                    <div className="menu-item">
                                        <Link className="menu-link" href={route('cobranza.catalogs.index', 'metodo-pago')}>
                                            <span className="menu-title">Método de pago</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {hasAnySecomMenuAccess() && (
                <div
                    data-kt-menu-trigger="click"
                    className={
                        'menu-item menu-accordion ' +
                        (secomActive ? 'here show hover ' : '') +
                        (secomActive ? 'active' : '')
                    }
                >
                    <span className="menu-link">
                        <IconWallet />
                        <span className="menu-title">SECOM</span>
                        <span className="menu-arrow" />
                    </span>
                    <div className={'menu-sub menu-sub-accordion ' + (secomActive ? 'show' : '')}>
                        {canEditSecomRecords() && (
                            <div className={'menu-item ' + (secomCreateActive ? 'active' : '')}>
                                <Link className="menu-link" href={route('secom.create')}>
                                    <span className="menu-bullet">
                                        <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Agregar registro</span>
                                </Link>
                            </div>
                        )}
                        {canViewSecomRecords() && (
                            <div className={'menu-item ' + (secomRecordsActive && !secomCreateActive ? 'active' : '')}>
                                <Link className="menu-link" href={route('secom.index')}>
                                    <span className="menu-bullet">
                                        <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Ver registros</span>
                                </Link>
                            </div>
                        )}
                        {canSecomUpdates() && (
                            <div className={'menu-item ' + (secomUpdatesActive ? 'active' : '')}>
                                <Link className="menu-link" href={route('secom.updates.index')}>
                                    <span className="menu-bullet">
                                        <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Actualizaciones</span>
                                </Link>
                            </div>
                        )}
                        {canSecomReports() && (
                            <div className={'menu-item ' + (secomReportsActive ? 'active' : '')}>
                                <Link className="menu-link" href={route('secom.reports')}>
                                    <span className="menu-bullet">
                                        <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Reportes</span>
                                </Link>
                            </div>
                        )}
                        {canSecomCatalogos() && (
                            <div className={'menu-item ' + (secomCatalogActive ? 'active' : '')}>
                                <Link className="menu-link" href={route('secom.catalogs.index')}>
                                    <span className="menu-bullet">
                                        <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Catálogo de status</span>
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    )
}

export function hasAnyOperationalModuleMenuAccess() {
    return (
        ['bitacora', 'reclutamiento', 'atencion-cliente'].some((module) =>
            canViewSiaModule(module, true),
        ) || hasAnySecomMenuAccess() || hasAnyCobranzaMenuAccess()
    )
}
